export default __webpack_public_path__ + "static/media/preview.146d92c5.png";